import { NgModule } from '@angular/core';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { KYMW4501Component } from './kymw4501.component';
import { GetFixFeatureService } from './api-services/get-fix-feature.service';
import { PlessSharedModule } from 'src/app/shared/pless-shared.module';

/**
 * 固定特集一覧 モジュール設定クラス
 *
 * @export KYMW4501Module
 * @class KYMW4501Module
 */
@NgModule({
  imports: [
    AppCommonsModule,
    PlessSharedModule,
    WjGridModule,
    WjGridFilterModule,
  ],
  declarations: [
    KYMW4501Component,
  ],
  providers: [
    GetFixFeatureService,
  ],
})

export class KYMW4501Module { }
